import React, { useState } from "react";
import { Send, Terminal } from "lucide-react";

export default function ChatInput({
  input,
  setInput,
  handleSend,
  chats,
  activeChatIndex,
  isLoading,
}) {
  const [historyIndex, setHistoryIndex] = useState(-1);

  const getUserMessages = () => {
    if (!chats[activeChatIndex]) return [];
    return chats[activeChatIndex].messages.filter((m) => m.role === "user");
  };

  const handleKeyDown = (e) => {
    const userMessages = getUserMessages();

    if (e.key === "ArrowUp") {
      e.preventDefault();
      if (userMessages.length > 0) {
        const newIndex =
          historyIndex === -1
            ? userMessages.length - 1
            : Math.max(0, historyIndex - 1);
        setHistoryIndex(newIndex);
        setInput(userMessages[newIndex].content);
      }
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      if (historyIndex !== -1) {
        const newIndex =
          historyIndex === userMessages.length - 1 ? -1 : historyIndex + 1;
        setHistoryIndex(newIndex);
        setInput(newIndex === -1 ? "" : userMessages[newIndex].content);
      }
    } else if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (!input.trim()) return;
      handleSend();
      setHistoryIndex(-1);
    }
  };

  return (
    <footer className="p-2 bg-slate-900 border-t "> {/* Reduced padding */}
      <div className="max-w-4xl mx-auto flex flex-col gap-1.5"> {/* Reduced gap */}
        
        {/* AI Loading Indicator */}
        {isLoading && (
          <div className="flex items-center space-x-2 px-2 py-0.5">
            <div className="flex space-x-1">
              <span className="w-1 h-1 bg-purple-500 rounded-full animate-bounce"></span>
              <span className="w-1 h-1 bg-purple-500 rounded-full animate-bounce [animation-delay:0.2s]"></span>
              <span className="w-1 h-1 bg-purple-500 rounded-full animate-bounce [animation-delay:0.4s]"></span>
            </div>
            <span className="text-[10px] text-gray-400 font-medium tracking-wide uppercase">
              Odoo AI is analyzing...
            </span>
          </div>
        )}

        {/* Input Bar */}
        <div className="relative flex items-center gap-2"> {/* Reduced gap */}
          <div className="flex-1 relative group">
            <div className="absolute inset-y-0 left-4 flex items-center pointer-events-none">
              <Terminal className="w-3.5 h-3.5 text-gray-400 group-focus-within:text-purple-500 transition-colors" />
            </div>
            <input
              className="w-full pl-10 pr-4 py-2.5 rounded-xl bg-gray-50 border border-gray-200 text-sm text-gray-900 focus:bg-white focus:ring-2 focus:ring-purple-500/20 focus:border-purple-500 outline-none transition-all placeholder:text-gray-400"
              type="text"
              placeholder="Ask Odoo AI..."
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={handleKeyDown}
              disabled={isLoading}
            />
          </div>

          <button
            disabled={!input.trim() || isLoading}
            className={`flex items-center justify-center p-2.5 rounded-xl transition-all shadow-sm
              ${!input.trim() || isLoading 
                ? "bg-gray-500 text-gray-300 cursor-not-allowed" 
                : "bg-gray-900 text-white hover:bg-purple-700 active:scale-95 shadow-purple-200"
              }`}
            onClick={() => {
              handleSend();
              setHistoryIndex(-1);
            }}
          >
            <Send className="w-4 h-4" /> {/* Slightly smaller icon */}
          </button>
        </div>
        
        <p className="text-[9px] text-center text-gray-400 uppercase tracking-widest">
          Connected to Odoo JSON-RPC
        </p>
      </div>
    </footer>
  );
}